<template>
  <div style="display: flex; margin: 30px; flex-direction: column;">
    <div style="margin: 10px; margin-top: 10px; display: flex; justify-content: space-between; align-items: center;">
      <div>
        <h1 style="font-size: 20px;">{{$t("_liste_des_installations_")}}</h1>      
      </div>
      <div style="display: flex; gap: 20px;">
        <div>
          <v-btn
            @click="toggleButton('btnperformance')"
          >
            {{ $t('_performance_') }}
          </v-btn>
        </div>
        <div>
          <v-btn
            @click="toggleButton('btnincident')"
          >
            {{ $t('_incidents_') }}
          </v-btn>
        </div>
        <div>
          <v-btn
            @click="toggleButton('btnconformite')"
          >
            {{ $t('_conformite_') }}
          </v-btn>
        </div>
      </div>
    </div>
    <div>
      <v-data-table
        :headers="takeheader()"
        :items="liste_parc"
        class="custom-data-table"
        :footer-props="{
                    'items-per-page-options': [20, 50, 100, -1],
                    'items-per-page-text': this.$t('_lignes_par_page_'),           
                  }"
        style="width: 100%;"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr
              v-for="item in items"
              :key="item.id"
              :class="{'disabled': item.is_forbidden}"
            >
              <td
                v-for="column in takeheader()"
                :key="column.value"
                :style="{ cursor: 'pointer' }"
                @click="goToInstallation(item, column.value)"
              >
                {{ item[column.value] }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </div>
    <v-btn style="margin: 10px; margin-left: -20px; width: 300px;">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    selectsite: {
      type: Array,
      required: true
    },
    liste_parc: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      btnperformance: JSON.parse(localStorage.getItem('btnperformance')) || false,
      btnincident: JSON.parse(localStorage.getItem('btnincident')) || false,
      btnconformite: JSON.parse(localStorage.getItem('btnconformite')) || false,
      chooseheader: [
        { text: this.$t('_nom_'), value: 'installation_name' },
        { text: '_puissance_crete_(kwc)_', value: 'pc_totale' },
        { text: '_commune_', value: 'city', value_two: 'country'},
        { text: '_groupe_d_installations_', value: 'installation_group' },
        { text: '_type_d_installation_(inclinaison_orientation)_', value: 'installation_type' },
        { text: '_mise_en_service_', value: 'start_date' },
        { text: '_productible_', value: 'productible' },
        { text: '_actualisation_audit_performance_', value: 'audit_performance' },
      ],
    };
  },

  computed: {
    ...mapGetters(["role", "cur_install_id", "constants", "installations"]),
  },

  methods: {
    toggleButton(button) {
      if (button === 'btnperformance') {
        this.btnperformance = !this.btnperformance;
        if (this.btnperformance) {
          this.btnincident = false;
          this.btnconformite = false;
        }
      } else if (button === 'btnincident') {
        this.btnincident = !this.btnincident;
        if (this.btnincident) {
          this.btnperformance = false;
          this.btnconformite = false;
        }
      } else if (button === 'btnconformite') {
        this.btnconformite = !this.btnconformite;
        if (this.btnconformite) {
          this.btnperformance = false;
          this.btnincident = false;
        }
      }
      localStorage.setItem('btnperformance', JSON.stringify(this.btnperformance));
      localStorage.setItem('btnincident', JSON.stringify(this.btnincident));
      localStorage.setItem('btnconformite', JSON.stringify(this.btnconformite));
    },

    isButtonDisabled(button) {
      if (button === 'btnperformance') {
        return this.btnincident || this.btnconformite;
      } else if (button === 'btnincident') {
        return this.btnperformance || this.btnconformite;
      } else if (button === 'btnconformite') {
        return this.btnperformance || this.btnincident;
      }
      return false;
    },

    takeheader() {
      let dynamicHeaders = [...this.chooseheader];

      if (this.btnperformance && !dynamicHeaders.some(header => header.text === 'performance')) {
        dynamicHeaders.push({ text: '_statut_de_performance_', value: 'statut' });
        dynamicHeaders.push({ text: '_performance_ratio_', value: 'pr_clean' });
        dynamicHeaders.push({ text: '_evolution_performance_ratio_', value: 'evolution_pr_clean' });
        dynamicHeaders.push({ text: '_indice_de_performance_', value: 'ip_clean' });
        dynamicHeaders.push({ text: '_evolution_indice_performance_', value: 'evolution_ip_clean' });
        dynamicHeaders.push({ text: '_disponibilite_', value: 'disponibilite' });
      }
      if (this.btnincident && !dynamicHeaders.some(header => header.text === 'incident')) {
        dynamicHeaders.push({ text: '_criticite_', value: 'criticite' });
        dynamicHeaders.push({ text: '_incidents_(ouverts)_', value: 'incidents' });
        dynamicHeaders.push({ text: '_alerts_(ouverts)_', value: 'alerte' });
        dynamicHeaders.push({ text: '_actions_', value: 'actions' });
      }
      if (this.btnconformite && !dynamicHeaders.some(header => header.text === 'conformite')) {
        dynamicHeaders.push({ text: '_conformite_contractuelle_', value: 'conformite_contractuelle' });
        dynamicHeaders.push({ text: '_conformite_pr_', value: 'conformite_pr' });
        dynamicHeaders.push({ text: '_conformite_disponibilite_', value: 'conformite_disponibilite' });
      }
      return dynamicHeaders;
    },

    searchstartdate(id) {
      let start_date = "";

      this.installations.forEach(element => {
        if (element.installation_id == id) {
          start_date = element.audit_start_date;
        }
      });
      return start_date;
    },

    searchenddate(id) {
      let end_date = "";

      this.installations.forEach(element => {
        if (element.installation_id == id) {
          end_date = element.audit_end_date;
        }
      });
      return end_date;
    },

    takeselectsites() {
      let sites = [];
      this.installations.forEach(element => {
        let cleanName = element.installation_name.trim();
        if (this.selectsite.includes(cleanName)) {
          sites.push(element);
        }
      });
      return sites;
    },

    goToInstallation(installation, columnKey) {
      if (columnKey !== "rapport") {
        this.$store.dispatch("setInstallationAuditDate", {
          start_date: this.searchstartdate(installation.id),
          end_date: this.searchenddate(installation.id),
        });

        this.$store.dispatch("setInstallationMaxDates", {
          start_date: this.searchstartdate(installation.id),
          end_date: this.searchenddate(installation.id)
        });

        this.$store.dispatch("setShowDateSelector", { show: true });
        this.$store.commit("SET_EXPERT_PDM", this.current_pdm);

        this.$store.commit("SET_GEO_PDM", '');

        this.$store.commit("SET_CUR_INSTALL_ID", installation.id);
        const path = `/installations/show/${installation.id}`;
        if (this.$route.path !== path) this.$router.push(path);
      }
    },
  },
};
</script>

<style scoped>
.custom-data-table {
  border-radius: 10px;
  overflow: hidden;
}

.custom-data-table .v-data-table-header {
  background-color: #e0e0e0;
}

.custom-data-table .v-data-table-header th {
  background-color: #e0e0e0;
}
</style>
